import { FileDoneOutlined } from '@ant-design/icons'
import ButtonComponent from './button-component'
import { useNavigate } from 'react-router-dom'
import { useGetOrganizationRecommendations } from '@BUP/hooks/Sociogram/recommendations/useGetOrganizationRecommendations'
import { Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'
import { capitalizeFirst } from '@BUP/utils'

const ResourcesButton = ({ survey, disabled }) => {
  const navigate = useNavigate()
  const i18n = useTranslation()
  const { courses } = survey
  const surveyName = courses[0].name

  const { isLoadingRecommendations, dataRecommendations, errorResultRecommendations } = useGetOrganizationRecommendations()

  const result = dataRecommendations?.find(result => result?.resultId === survey.results[0]?.id)

  const handleViewResources = () => {
    if (navigate) {
      navigate(
        `/sociogram/${survey.id}/results/${result?.resultId}/recommendations`, {
          state: {
            surveyName
          }
        }
      )
    }
  }

  return (
    <Tooltip
      title={errorResultRecommendations ? i18n.t('common.resources.recommendation_resources.actions.read.failure') : null}
      placement='top'
    >
      <span>
        <ButtonComponent
          buttonText={capitalizeFirst(i18n.t('common.resources.recommendation_resources.label', { count: 2 }))}
          colorType='secondary'
          icon={<FileDoneOutlined />}
          disabled={disabled || !result || errorResultRecommendations}
          onClick={() => handleViewResources()}
          loading={isLoadingRecommendations}
        />
      </span>
    </Tooltip>
  )
}

export default ResourcesButton
